import React from 'react';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { PUBLICATION_STATUS } from 'constants/constants';
import messages from './messages';

import {
  PublishStatusStyle,
  PublishStatusCircle,
  HollowCircle,
} from './styles';

const PublishStatusIcon = ({
  activity,
  theme,
}) => {
  let publicationDetails = activity?.publicationDetails;
  let marketsExist = publicationDetails?.markets?.length > 0;
  const allMarkets = []; // Temporary logic until BACW-746 comes in.
  if (Array.isArray(publicationDetails)) {
    let indexToUseForStatus = 0;
    // Temporary logic until BACW-746 comes in.
    publicationDetails.forEach((detail, index) => {
      if (detail.oculusStatus === PUBLICATION_STATUS.IN_REVIEW || detail.oculusStatus === PUBLICATION_STATUS.PUBLISHED_LIVE) {
        indexToUseForStatus = index;
      }
      // Temporary logic until BACW-746 comes in.  publicationOutputType "BV:High School" tells us the market name (and markets exist)
      if(detail.publicationOutputType.split(':').length > 1) {
        marketsExist = true;
        allMarkets.push(detail.publicationOutputType.split(':')[1]);
      }
    });
    publicationDetails = publicationDetails[indexToUseForStatus];
  }
  if (!publicationDetails) {
    return <></>;
  }
  const currentStatus = publicationDetails.oculusStatus;
  if (!currentStatus) {
    return (
      <HollowCircle>
        <PublishStatusStyle>Status Unknown</PublishStatusStyle>
      </HollowCircle>
    );
  }
  const renderMarkets = () => (
    <>
      {marketsExist ? <div>{intl.formatMessage(messages.marketsExist)}</div> : <></>}
    </>
  );

  const renderStatus = (color, label) => (
    <PublishStatusCircle color={color} marketsExist={marketsExist}>
      <PublishStatusStyle>{label}{renderMarkets()}</PublishStatusStyle>
    </PublishStatusCircle>
  );
  switch (currentStatus) {
    case PUBLICATION_STATUS.IN_REVIEW:
      return renderStatus(theme['color.magenta'], intl.formatMessage(messages.inReview));
    case PUBLICATION_STATUS.PUBLISHED_LIVE:
      return renderStatus(theme['color.green'], intl.formatMessage(messages.publishedLive));
    default:
      return null;
  }
};

export default PublishStatusIcon;
